/**
 * 设备唯一标识管理
 * 用于追踪匿名上传的文件
 */

const DEVICE_ID_KEY = 'easy_share_device_id'

/**
 * 生成设备唯一标识 (UUID v4 格式)
 */
function generateDeviceId(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * 获取或创建设备ID
 */
export function getDeviceId(): string {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY)
  
  if (!deviceId) {
    deviceId = generateDeviceId()
    localStorage.setItem(DEVICE_ID_KEY, deviceId)
  }
  
  return deviceId
}

/**
 * 重置设备ID（仅用于测试）
 */
export function resetDeviceId(): string {
  const newId = generateDeviceId()
  localStorage.setItem(DEVICE_ID_KEY, newId)
  return newId
}

/**
 * 清除设备ID
 */
export function clearDeviceId(): void {
  localStorage.removeItem(DEVICE_ID_KEY)
}
